import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { PieData } from "../../../../shared/services/interface";

type Props = {
  piechartData: PieData[];
  Header: string;
};

export default function PieArcLabel({ piechartData, Header }: Props) {
  return (
    <div className='flex flex-col w-full p-4 bg-white dark:bg-slate-400 rounded-lg shadow-md'>
      <h2 className='text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4'>{Header}</h2>

      {/* Chart wrapper with controlled height */}
      <div className='w-full flex justify-center'>
        <div className='relative w-full max-w-[500px] h-[320px]'>
          <PieChart
            height={320}
            series={[
              {
                data: piechartData,
                arcLabel: (item) => (item.value >= 10 ? `${item.value}` : ""),
                arcLabelMinAngle: 35,
                arcLabelRadius: "85%",
                innerRadius: 20,
                paddingAngle: 3,
                cornerRadius: 6,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
